import { footerTemplate2Blueprint } from "@made-people/blueprint-footer/blueprint";
import { partnerLogosTemplate1Blueprint } from "@made-people/blueprint-partner-logos/blueprint";

footerTemplate2Blueprint.main.override({
  slots: {
    background: "bg-surface-1 py-12 lg:py-16",
    wrapper:
      "grid grid-flow-row auto-rows-max gap-12 lg:grid-cols-12 lg:gap-5 lg:gap-y-10 items-start",

    text: "order-4 grid-span-full lg:col-start-1 lg:col-end-4 lg:row-start-3 lg:mt-10 lg:self-center justify-self-center lg:justify-self-start",

    countries:
      "justify-self-start lg:row-start-3 lg:col-start-10 lg:col-end-13 lg:mt-10 lg:self-end w-full",

    menuWrapper: "",
    menuAccordion: "lg:hidden",
    menuList:
      "hidden lg:grid lg:col-start-1 lg:col-end-10 lg:grid-cols-subgrid lg:row-start-2 text-body-lg",
    menuListMenu: "flex flex-col gap-2 text-body-md items-start col-span-3",
    menuListMenuHeading: "mb-2",

    logo: "w-full lg:row-start-3 lg:col-start-3 lg:col-span-full lg:mt-10 lg:self-end",
    partnerLogos:
      "lg:row-start-3 lg:col-start-4 lg:col-end-10 lg:mt-10 lg:self-center",
  },
});

footerTemplate2Blueprint.accordion.override({
  slots: {
    base: "lg:-mx-[--spacing-x]",
    trigger:
      "flex items-center justify-between w-full py-4 cursor-pointer group/facet-trigger text-label-md font-medium text-left gap-4",
    content: "pb-6 pt-2 flex flex-col text-label-md gap-6",
    item: "border-b border-black/10",
    header: "",
    headerWrapper: "flex items-center gap-2",
    headerLeftImage: "w-5 h-5",
    iconOpen: "group-data-[state=open]:hidden size-3",
    iconClose: "group-data-[state=closed]:hidden size-3",
  },
});

partnerLogosTemplate1Blueprint.override({
  slots: {
    wrapper:
      "flex flex-row gap-4 lg:gap-6 items-center justify-center lg:justify-start",
    logo: "h-5 w-auto max-w-12 lg:max-w-none",
  },
});
